import React from 'react';
import { injectIntl } from 'react-intl';
import classnames from 'classnames';

import styles from './index.module.scss';
import SchoolPng from './img/school.png';
import * as messages from './messages';

const AboutUs = props => {
  const { intl: { formatMessage } } = props;

  return (
    <div className={styles.about}>
      <img src={SchoolPng} alt="school" className={classnames(styles.heroImage)} />
      <div className="container-fluid">
        <div className="row">
          <article className={classnames('col-12 col-md-8 offset-md-2', styles.hero)}>
            <h1>{formatMessage(messages.title.ngeeann)}</h1>
            <p>{formatMessage(messages.content.ngeeannOne)}</p>
            <p>{formatMessage(messages.content.ngeeannTwo)}</p>

            <h1>{formatMessage(messages.title.sginnovate)}</h1>
            <p>{formatMessage(messages.content.sginnovateOne)}</p>
            <p>{formatMessage(messages.content.sginnovateTwo)}</p>
            <p>{formatMessage(messages.content.sginnovateThree)}</p>

            <h1>{formatMessage(messages.title.indorse)}</h1>
            <p>{formatMessage(messages.content.indorseOne)}</p>
          </article>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(AboutUs);



// WEBPACK FOOTER //
// ./src/ui/pages/about-us/index.js